import { onBeforeUnmount, ref, watch, type Ref } from 'vue'

/** 冷启动骨架最短停留时间。数据返回更快时补足这段，避免骨架闪一下就消失。 */
export const SKELETON_MIN_VISIBLE_MS = 400

/**
 * `active` 为真时立刻显示。变为假时，若还没到最短时间，则继续显示到时间结束。
 */
export function useSkeletonHold(active: Ref<boolean>, minMs = SKELETON_MIN_VISIBLE_MS) {
  const visible = ref(false)
  let shownAt = 0
  let timer: ReturnType<typeof setTimeout> | undefined

  function clearTimer() {
    if (timer === undefined) return
    clearTimeout(timer)
    timer = undefined
  }

  watch(
    active,
    (show) => {
      if (show) {
        shownAt = Date.now()
        visible.value = true
        clearTimer()
        return
      }

      if (!visible.value) return

      const remain = minMs - (Date.now() - shownAt)
      if (remain <= 0) {
        visible.value = false
        return
      }

      timer = setTimeout(() => {
        visible.value = false
        timer = undefined
      }, remain)
    },
    { immediate: true },
  )

  onBeforeUnmount(clearTimer)

  return visible
}
